import { render } from "./ReportStatDoctorsDatatableHtmlChequeTotal.vue?vue&type=template&id=2a76ddf0"
import script from "./ReportStatDoctorsDatatableHtmlChequeTotal.vue?vue&type=script&lang=js"
export * from "./ReportStatDoctorsDatatableHtmlChequeTotal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__